import axios from "axios";

export const forgetPassApi = async (credintial, lang) => {
  let data = JSON.stringify({
    email: credintial.email,
  });

  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API}/forget-password`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
